import classNames from 'classnames'

import Image from '../ui/Image/Image'
import bulletIcon from '../../assets/images/bullet.svg'
import styles from './BulletList.module.scss'

function BulletList({ bulletList = [], className, textClass }) {
  return (
    <div className={classNames(styles.listContainer, className)}>
      {bulletList?.length > 0 &&
        bulletList.map((list) => {
          return (
            <div
              key={'bulletList' + list?.id}
              className={classNames(styles.bulletContainer)}
            >
              <Image src={bulletIcon} alt={'bullet'} className={styles.image} />
              <span
                className={classNames(styles.bulletTitle, styles['fade-in'])}
              >
                {list.title}
              </span>
            </div>
          )
        })}
    </div>
  )
}

export default BulletList
